import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import classNames from "../../helpers/classNames";
import { useEditor } from "../../hooks/EditorProvider";
import DraggableComponent from "./DraggableComponent";
import { DraggableComponentTypes, } from "../../types/draggable";
import DraggableAddComponent from "./DraggableAddComponent";
import { v4 as uuidv4 } from "uuid";
const DraggableBox = ({ draggableId, elementId, childs = [], className, focusKey, editorKey, type, component: Component = "div", text, style, ...props }) => {
    const { draggableAddComponent, dragActive, mode, editableItem, iframeMount, dragElementMenu, content, addElement, elements, } = useEditor();
    const [activeDragOver, setActiveDragOver] = useState(false);
    const handleDragOver = (e) => {
        const targetId = e.target
            .closest("[editor-draggablebox]")
            ?.getAttribute("editor-draggablebox");
        e.preventDefault();
        if (draggableId === targetId && dragActive) {
            setActiveDragOver(true);
        }
    };
    const handleDragLeave = (e) => {
        setActiveDragOver(false);
    };
    const handleDrop = (e) => {
        const targetId = e.target
            .closest("[editor-draggablebox]")
            ?.getAttribute("editor-draggablebox");
        e.preventDefault();
        if (draggableId === targetId) {
            if (e.dataTransfer.getData("block")) {
                const elementDrag = Object.values(elements)
                    .flat()
                    .find((element) => element?.element === e.dataTransfer.getData("block")) || null;
                const elementData = {
                    id: uuidv4(),
                    type: e.dataTransfer.getData("block"),
                    props: elementDrag?.props ? JSON.parse(elementDrag?.props) : {},
                };
                return addElement(elementData, content.findIndex((c) => c.id === elementId) + 1);
            }
            const componentType = e.dataTransfer.getData("editor-component-drag-type");
            const componentData = e.dataTransfer.getData("editor-component-drag-item");
            setActiveDragOver(false);
            if (componentType) {
                const cData = componentData ? JSON.parse(componentData) : null;
                draggableAddComponent(draggableId, componentType, elementId, cData);
            }
        }
    };
    if (mode === "production") {
        return (_jsxs(Component, { ...(className && { className }), ...(style && { style }), children: [childs?.map((item) => (_jsx(DraggableComponent, { item: item, elementId: elementId }, item.id))), text && _jsx(_Fragment, { children: text })] }));
    }
    const handleGridEdit = () => {
        const target = iframeMount
            ?.querySelector(`[editor-elementid='${elementId}']`)
            ?.querySelector(`[editor-key='${editorKey}']`);
        target?.click();
    };
    return (_jsxs(Component, { "editor-focuskey": focusKey, "editor-key": focusKey ? null : editorKey, "editor-draggablebox": draggableId, "editor-has-childs": (childs?.length > 0).toString(), onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop, 
        // onClick={handleRightClick}
        // onContextMenu={handleRightClick}
        className: mode !== "production"
            ? classNames(className, "editor-drag-grid", activeDragOver &&
                type !== DraggableComponentTypes.Grid &&
                "editor-drag-selected"
            // childs?.length === 0 && "p-4"
            )
            : className, style: style, ...props, children: [type === DraggableComponentTypes.Grid &&
                editableItem?.getAttribute("editor-key") !== editorKey &&
                editableItem?.getAttribute("editor-key")?.includes(editorKey) && (_jsx("span", { className: "absolute -top-11 right-2 isolate z-10 rounded-xl shadow", children: _jsx("button", { onClick: handleGridEdit, type: "button", className: "relative -ml-px inline-flex items-center rounded border border-gray-300 bg-white px-4 py-2 text-xs font-medium  hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1", children: "Grid instellingen" }) })), childs?.map((item) => (_jsx(DraggableComponent, { item: item, elementId: elementId }, item.id))), text && _jsx(_Fragment, { children: text }), activeDragOver && _jsx("div", { className: "h-[2px] w-full bg-green-500" }), childs?.length === 0 && !text && (_jsx("div", { className: "flex w-full justify-center my-4", "editor-focuskey": editorKey, children: _jsx(DraggableAddComponent, { draggableId: draggableId, elementId: elementId }) }))] }));
};
export default DraggableBox;
//# sourceMappingURL=DraggableBox.js.map